import { ValidationErrors } from '@angular/forms';
import { Cmg1003SectionTypes } from './section-types.enum';
import { Cmg1003SubSectionTypes } from './sub-section-types.enum';

export class InvalidControlModel {
  formControlName?: string;
  controlId?: string;
  originalId?: number;
  invalidMessage: string;
  excludeFromAus?: boolean; // For validations which are used as a hard stop but which should not display in AUS panel (e.g. Minimum Draw Amount)
  action?: any;
  errors?: ValidationErrors;
}

export class ValidationFailureModel {
  section: Cmg1003SectionTypes;
  subSection: Cmg1003SubSectionTypes;
  invalidControls: InvalidControlModel[];
}
